import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let valuesSwiperWr = document.querySelectorAll('.values-swiper-wr');
valuesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    const valueCards = Array.from(el.querySelectorAll('.value-card'));

    const syncActiveSlideState = (instance) => {
      const isMobile = window.innerWidth <= 640;

      valueCards.forEach((card, index) => {
        const isActive = isMobile && index === instance.activeIndex;
        card.classList.toggle('is-slide-active', isActive);
      });
    };

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 20,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        641: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        1023: {
          spaceBetween: 16,
          slidesPerView: 4,
        },
        1200: {
          spaceBetween: el.classList.contains('industries-type') ? 19 : 23,
          slidesPerView: el.classList.contains('industries-type') ? 5 : 4,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        init(instance) {
          syncActiveSlideState(instance);
        },
        slideChange(instance) {
          syncActiveSlideState(instance);
        },
        resize(instance) {
          syncActiveSlideState(instance);
        },
        breakpoint(instance) {
          syncActiveSlideState(instance);
        },
      }
    });
    swiperObserver(swiper);
    syncActiveSlideState(swiper);

    const valuesCardsTitlesArr = swiperEl.querySelectorAll('.value-card__title');
    const valuesCardsContentsArr = swiperEl.querySelectorAll('.value-card__content');

    if(valuesCardsTitlesArr.length) {
      window.lineTitlesFunc(valuesCardsTitlesArr);
    }

    if(valuesCardsContentsArr.length) {
      window.lineTitlesFunc(valuesCardsContentsArr);
    }
  }
});
